import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { Row, Col, Label, Container } from "reactstrap";
import { PENCIL } from "../../Constants/SrcImages";
import {validateTokenStorage} from './../../Constants/Util';
import { COLUMNS_TEACHERS_EXPAND_ROW, EXPAND_ROW_TEACHER } from "../../Constants/DatatableColumns";
import { getGrades,getAllsignature,getHourAsigTeacher,postHourAsiTeacher,putHourAsigTeacher,getAllTeachers } from "../../Constants/Services";
import { IGrades, IPersonSelected,IHourAsTeacher,IAsignature,IDiasByAsignaturesGrade,ITeachers } from "../../Constants/Interfaces";
import {AsignarMateriaModal} from './../../Constants/Modal';
import moment from "moment";

interface IAMateriaState {
  formDias:IDiasByAsignaturesGrade;
  dataAsignature: IAsignature[];
  dataTeachers:ITeachers[];
  dataHourAsTeacher:IHourAsTeacher[];
  dataPersonSelected: IPersonSelected;
  dataGrades: IGrades[];
  isOpenModalAddHour:boolean;
  isOpenModalEditHour:boolean;
  loading:boolean;
  msg_error:string;
}

class AMaterias extends Component<RouteComponentProps<{}>, IAMateriaState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataHourAsTeacher:[],
      dataAsignature:[],
      dataTeachers: [],
      formDias:{
        tas_id:"",
        tas_periodo:"",
        asid_lunes:"",
        asdesc_lunes:"",
        grid_lunes:"",
        grdesc_lunes:"",
        asid_martes:"",
        asdesc_martes:"",
        grid_martes:"",
        grdesc_martes:"",
        asid_miercoles:"",
        asdesc_miercoles:"",
        grid_miercoles:"",
        grdesc_miercoles:"",
        asid_jueves:"",
        asdesc_jueves:"",
        grid_jueves:"",
        grdesc_jueves:"",
        asid_viernes:"",
        asdesc_viernes:"",
        grid_viernes:"",
        grdesc_viernes:"",
        tas_hourstar:new Date().toString(),
        tas_hourend:new Date().toString()
      },
      dataGrades: [],
      dataPersonSelected: {
        per_id: "",
        per_name: "",
      },
      isOpenModalAddHour:false,
      isOpenModalEditHour:false,
      loading:false,
      msg_error:""
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchAsigTeacher = this.fetchAsigTeacher.bind(this);
    this.fetchAsignature = this.fetchAsignature.bind(this);
    this.setAsignatura = this.setAsignatura.bind(this);
    this.setGrade = this.setGrade.bind(this);
    this.handlerModalADDHour = this.handlerModalADDHour.bind(this);
    this.onChangeDatePickerStart = this.onChangeDatePickerStart.bind(this);
    this.onChangeDatePickerEnd = this.onChangeDatePickerEnd.bind(this);
    this.handlerPostHour = this.handlerPostHour.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handlerModaleditHour = this.handlerModaleditHour.bind(this);
    this.handlerSetDataEdit = this.handlerSetDataEdit.bind(this);
    this.columnModalEditHour = this.columnModalEditHour.bind(this);
    this.handlerPutHour = this.handlerPutHour.bind(this);
    this.setNullHour = this.setNullHour.bind(this);
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
    });
  }

  async fetchTeachers() {
    const response = await getAllTeachers();
    this.setState({
      dataTeachers: response,
    });
  }

  async fetchAsignature() {
    const response = await getAllsignature();
    this.setState({
      dataAsignature: response,
    });
  }

  async fetchAsigTeacher({per_id, per_name}) {
    const response = await getHourAsigTeacher(per_id);
    this.setState({
      dataHourAsTeacher: response,
      dataPersonSelected: { per_id, per_name },
      loading:false
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchGrade();
    this.fetchAsignature();
    this.fetchTeachers();
  }

  handlerModalADDHour() {
    this.setState((prevState) => ({
      isOpenModalAddHour: !prevState.isOpenModalAddHour,
      formDias:{
        tas_id:"",
        tas_periodo:"",
        asid_lunes:"",
        asdesc_lunes:"",
        grid_lunes:"",
        grdesc_lunes:"",
        asid_martes:"",
        asdesc_martes:"",
        grid_martes:"",
        grdesc_martes:"",
        asid_miercoles:"",
        asdesc_miercoles:"",
        grid_miercoles:"",
        grdesc_miercoles:"",
        asid_jueves:"",
        asdesc_jueves:"",
        grid_jueves:"",
        grdesc_jueves:"",
        asid_viernes:"",
        asdesc_viernes:"",
        grid_viernes:"",
        grdesc_viernes:"",
        tas_hourstar:new Date().toString(),
        tas_hourend:new Date().toString()
      },
      msg_error:""
    }));
  }

  handlerModaleditHour() {
    this.setState((prevState) => ({
      isOpenModalEditHour: !prevState.isOpenModalEditHour,
      msg_error:""
    }));
  }

  setAsignatura = (as_id, as_desc, asid,asdesc) => {
    this.setState({
      formDias: {
        ...this.state.formDias,
        [asid]: as_id,
        [asdesc]: as_desc
      },
      msg_error:""
    });
  };
  
  setGrade = (gr_id, gr_desc, grid,grdesc) => {
    this.setState({
      formDias: {
        ...this.state.formDias,
        [grid]: gr_id,
        [grdesc]: gr_desc
      },
      msg_error:""
    });
  };
  
  onChangeDatePickerStart(date: any) {
    this.setState({
      formDias: {
        ...this.state.formDias,
        tas_hourstar: date,
      },
      msg_error:""
    });
  }

  onChangeDatePickerEnd(date: any) {
    this.setState({
      formDias: {
        ...this.state.formDias,
        tas_hourend: date,
      },
      msg_error:""
    });
  }

  handlerPostHour() {
    const  props = this.state.formDias;
    const  propsPerson = this.state.dataPersonSelected;
    const body = {
      tas_person:propsPerson.per_id,
      tas_hourstar:moment(props.tas_hourstar).format("YYYY-MM-DD HH:mm:ss"),
      tas_hourend:moment(props.tas_hourend).format("YYYY-MM-DD HH:mm:ss"),
      tas_lunes:props.asid_lunes,
      tas_lunesgr:props.grid_lunes,
      tas_martes:props.asid_martes,
      tas_martesgr:props.grid_martes,
      tas_miercoles:props.asid_miercoles,
      tas_miercolesgr:props.grid_miercoles,
      tas_jueves:props.asid_jueves,
      tas_juevesgr:props.grid_jueves,
      tas_viernes:props.asid_viernes,
      tas_viernesgr:props.grid_viernes
    };

      postHourAsiTeacher(body);
      this.setState({ isOpenModalAddHour: false, msg_error:""});
      setTimeout(() => {
        this.fetchAsigTeacher({per_id:propsPerson.per_id, per_name:propsPerson.per_name});
      }, 1000);
  }

  handlerPutHour() {
    const  props = this.state.formDias;
    const  propsPerson = this.state.dataPersonSelected;
    const body = {
        tas_id:props.tas_id,
        tas_hourstar:moment(props.tas_hourstar).format("YYYY-MM-DD HH:mm:ss"),
        tas_hourend:moment(props.tas_hourend).format("YYYY-MM-DD HH:mm:ss"),
        tas_lunes:props.asid_lunes,
        tas_lunesgr:props.grid_lunes,
        tas_martes:props.asid_martes,
        tas_martesgr:props.grid_martes,
        tas_miercoles:props.asid_miercoles,
        tas_miercolesgr:props.grid_miercoles,
        tas_jueves:props.asid_jueves,
        tas_juevesgr:props.grid_jueves,
        tas_viernes:props.asid_viernes,
        tas_viernesgr:props.grid_viernes
    };
    putHourAsigTeacher(body);
    this.setState({ isOpenModalEditHour: false,loading:true});
    setTimeout(() => {
      this.fetchAsigTeacher({per_id:propsPerson.per_id, per_name:propsPerson.per_name});
    }, 1000);
  }

  rechargeData() {
    const propsPerson = this.state.dataPersonSelected;
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchAsigTeacher({per_id:propsPerson.per_id, per_name:propsPerson.per_name});
    }, 1000);
  }

  handlerSetDataEdit(row:any) {
    this.setState((prevState) => ({
      formDias: row,
      isOpenModalEditHour:true
    }));
  }
  
  columnModalEditHour(cell, row) {
    return (
      <React.Fragment>
      <Row>
        <Col xs={12} className="d-flex">
        <Label className="txt-underline" onClick={() => this.handlerSetDataEdit(row)}>
          {row.tas_periodo}
        </Label>
        <img className="img-status img-search" onClick={() => this.handlerSetDataEdit(row)} src={PENCIL} alt="" />
        </Col>
      </Row>
      </React.Fragment>
    );
  }

  setNullHour = (day:string) => {
    if(day==="1"){
      this.setState({
        formDias: {
          ...this.state.formDias,
          asid_lunes:"",
          asdesc_lunes:"",
          grid_lunes:"",
          grdesc_lunes:"",
        },
      });
    }
    if(day==="2"){
      this.setState({
        formDias: {
          ...this.state.formDias,
          asid_martes:"",
          asdesc_martes:"",
          grid_martes:"",
          grdesc_martes:"",
        },
      });
    }
    if(day==="3"){
      this.setState({
        formDias: {
          ...this.state.formDias,
          asid_miercoles:"",
          asdesc_miercoles:"",
          grid_miercoles:"",
          grdesc_miercoles:"",
        },
      });
    }
    if(day==="4"){
      this.setState({
        formDias: {
          ...this.state.formDias,
          asid_jueves:"",
          asdesc_jueves:"",
          grid_jueves:"",
          grdesc_jueves:"",
        },
      });
    }
    if(day==="5"){
      this.setState({
        formDias: {
          ...this.state.formDias,
          asid_viernes:"",
          asdesc_viernes:"",
          grid_viernes:"",
          grdesc_viernes:"",
        },
      });
    }

  };

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalAddHour && (
          <AsignarMateriaModal
            title= {`Asignar materia Prof. ${props.dataPersonSelected.per_name}`}
            dataForm= {props.formDias}
            dataAsig={props.dataAsignature}
            dataGrade={props.dataGrades}
            setAsignatura={this.setAsignatura}
            setGrade = {this.setGrade}
            onChangeDatePickerStart={this.onChangeDatePickerStart}
            onChangeDatePickerEnd={this.onChangeDatePickerEnd}
            isOpen={props.isOpenModalAddHour}
            toggle={this.handlerModalADDHour}
            toggleSave={this.handlerPostHour}
            msg_error={props.msg_error}
            setNullHour={this.setNullHour}
          />
        )}

        {props.isOpenModalEditHour && (
          <AsignarMateriaModal
            title="Editar"
            dataForm= {props.formDias}
            dataAsig={props.dataAsignature}
            dataGrade={props.dataGrades}
            setAsignatura={this.setAsignatura}
            setGrade = {this.setGrade}
            onChangeDatePickerStart={this.onChangeDatePickerStart}
            onChangeDatePickerEnd={this.onChangeDatePickerEnd}
            isOpen={props.isOpenModalEditHour}
            toggle={this.handlerModaleditHour}
            toggleSave={this.handlerPutHour}
            msg_error={props.msg_error}
            setNullHour={this.setNullHour}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Asignar materia</h3>
              </Label>
            </Col>
            <Col sm={12} className="text-right mb-3"></Col>
            <Col sm={12}>
              <DatatableExpand
                data={props.dataTeachers}
                columns={COLUMNS_TEACHERS_EXPAND_ROW()}
                keyProp="per_id"
                expandRow={EXPAND_ROW_TEACHER(
                  props.dataHourAsTeacher,
                    this.fetchAsigTeacher,
                    this.handlerModalADDHour,
                    this.rechargeData,
                    props.loading,
                    this.columnModalEditHour
                  )}
                exportD={false}
                searchs={true}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default AMaterias;
